import '@d3fc/d3fc-element';
import { line } from 'utils/components/TimeSeriesChart/line';
import { SignalChartTimeSeriesItem } from 'widgets/signalTiles/signalTile/components/chart/signalTileData';

export const valueLine = line<SignalChartTimeSeriesItem>(
    (d) => d.value,
    'middle-line'
);
